import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const getAllServicesWithSubServices = () => {
  return Api(endPoints.getAllServicesWithSubServices, null, requestType.GET);
};

const getAllCompanyServices = (id) => {
  return Api(`${endPoints.getAllCompanyServices}/${id}`, null, requestType.GET);
};

const getAllCompanySubServices = (id, serviceId) => {
  return Api(
    `${endPoints.getAllCompanySubServices}/${id}/${serviceId}`,
    null,
    requestType.GET
  );
};

const createCompanyServices = (params) => {
  return Api(endPoints.createCompanyServices, params, requestType.POST);
};

const getCompanyServices = (companyId, mainServiceId) => {
  return Api(
    `${endPoints.getCompanyServices}/${companyId}/${mainServiceId}`,
    null,
    requestType.GET
  );
};
const getCompanyPreSelectedServices = (companyId) => {
  return Api(
    `${endPoints.getCompanyPreSelectedServices}/${companyId}`,
    null,
    requestType.GET
  );
};

const updateCompanyOwnSerivce = (id, params) => {
  return Api(
    `${endPoints.updateCompanyOwnSerivce}/${id}`,
    params,
    requestType.PUT
  );
};

const getCompanySelectedServices = (id, params) => {
  return Api(
    `${endPoints.getCompanySelectedServices}/${id}`,
    null,
    requestType.GET
  );
};

const getCompanyPopularServices = (id) => {
  return Api(
    `${endPoints.getCompanyPopularService}/${id}`,
    null,
    requestType.GET
  );
};

export {
  getAllServicesWithSubServices,
  getAllCompanyServices,
  getAllCompanySubServices,
  createCompanyServices,
  getCompanyServices,
  updateCompanyOwnSerivce,
  getCompanyPreSelectedServices,
  getCompanySelectedServices,
  getCompanyPopularServices
};
